var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0b6ccc11-d30a-4dbb-b56c-55f8555d49fd",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1006.96 682.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-064e3e93-9940-443b-971c-dab2ce32fd79",
    d: "M1005.14,32.94c-.2-.96.39-1.91.1-2.87-.16-.57-.76-.82-.94-1.37-2.54-7.52-7.05-13.79-13.03-18.72-1.23-1-2.4-1.62-3.71-2.48-6.6-4.34-14.05-7.5-22.56-7.5H41.96c-8.5,0-15.96,3.15-22.56,7.5-1.31.84-2.5,1.48-3.71,2.48-6,4.94-10.47,11.21-13.01,18.72-.2.55-.8.8-.96,1.37-.29.96.31,1.91.1,2.87-.68,2.99-1.82,5.82-1.82,9.01v598.12c0,23.19,18.79,41.96,41.96,41.96h923.05c23.17,0,41.96-18.77,41.96-41.96V41.96c0-3.2-1.15-6.02-1.82-9.01ZM823.12,83.91l-319.63,207.16L183.84,83.91h639.27ZM83.91,598.12V119.17l396.76,257.12c6.94,4.51,14.89,6.72,22.82,6.72s15.88-2.21,22.82-6.72L923.05,119.17v478.95H83.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.d6345fa50f60b559b35f5ca3d0750cb1.svg";
export { ForwardRef as ReactComponent };